module.exports = __webpack_public_path__ + "img/retour-arrow.96452b07.svg";